interface CategoriesTileProps {
    label: string;
    name: string;
    register: any;
    error?: string;
    disabled?: boolean;
    className?: string;
    clickEvent: (event: React.MouseEvent<HTMLDivElement>) => void;
    isSelected: boolean;
}

export default function CategoriesTile({
    label,
    register,
    error,
    clickEvent,
    disabled = false,
    className = "",
    isSelected
}: CategoriesTileProps) {
    return (
        <div 
            onClick={disabled ? undefined : clickEvent}
            className={`
                w-full cursor-pointer rounded-md border p-4 transition-all bg-white 
                ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:border-primary hover:bg-primary-50'}
                ${isSelected ? 'border-primary ' : 'border-[#EDE8E4]'}
                ${className}
            `}
        >
            <div className="flex items-center space-x-3">
                <input
                    type="radio"
                    {...register}
                    checked={isSelected}
                    disabled={disabled}
                    onChange={() => {}} 
                    className={`
                        h-4 w-4 cursor-pointer rounded-full border
                        text-primary transition-colors
                        focus:ring-2 focus:ring-primary focus:ring-offset-2
                        disabled:cursor-not-allowed disabled:opacity-50
                        ${error ? "border-red-500" : "border-gray-300"}
                    `}
                />
                <label className={`flex-1 font-medium ${disabled ? "text-gray-400" : "text-gray-700"}`}>
                    {label}
                </label>
            </div>
            {error && (
                <p className="mt-2 text-sm text-red-600">
                    {error}
                </p>
            )}
        </div>
    );
};